import React from 'react';
import {Link} from 'react-router-dom';
import articles from '../data/articles.json';

const RightSideBar = (props)=> {

    let recent = articles.articles.filter((article) => {
		return article.recent === true;
	});

    return (
        <div className="right-side-bar">
            <h4>Recent Articles</h4>
            <ul>
                {
                    recent.map((obj, i)=>{
                        return (
                            <li key={i}>
                                <Link
                                    to={"/blog/"+obj.title.replace(/[\W_]/g, " ").replace(/\s+/g, '-').toLowerCase()}>
                                        {obj.title}
                                </Link>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default RightSideBar;


// WEBPACK FOOTER //
// ./src/view/RightSideBar.js